import { RouteObject, Navigate } from "react-router-dom";
import AdminRoot from "../components/roots/admin-root/AdminRoot";
import Dashboard from "../pages/dashboard/Dashboard";
import Login from "../pages/login/Login";
import Categories from "../pages/categories/Categories";
import Settings from "../pages/settings/Settings";
import Products from "../pages/products/Products";
import Brands from "../pages/brands/Brands";
import Countries from "../pages/countries/Countries";
import Partners from "../pages/partners/Partners";
import News from "../pages/news/News";
import Colors from "../pages/colors/Colors";
import Pages from "../pages/pages/Pages";
import NotFound from "../pages/not-found/NotFound";
import CategorySpecs from "../pages/category-specs/CategorySpecs";
import Permissions from "../pages/permissions/Permissons";
import Campaigns from "../pages/campaigns/Campaigns";
import Services from "../pages/services/Services";
import { getCookie } from "../utils/utils";
import GroupNames from "../pages/group-names/GroupNames";
import Vacancy from "../pages/vacancy/Vacancy";
import Blogs from "../pages/blogs/Blogs";
import Video from "../pages/video/Video";
import Branchs from "../pages/branchs/Branchs";
import Contact from "../pages/contact/Contact";
import RepairOrder from "../pages/repair-order/RepairOrder";
import WeeklyPicks from "../pages/weekly-picks/WeeklyPicks";
import ServicesGroup from "../pages/services-group/ServicesGroup";
import OrderStatus from "../pages/order-status/OrderStatus";
import About from "../pages/about/About";
import ProductOrders from "../pages/product_orders/ProductOrders";
import ServiceOrders from "../pages/service_orders/ServiceOrders";
import AccessoryOrders from "../pages/accessory_orders/AccessoryOrders";
import OfficialService from "../pages/official-service/OfficialService";
// import InstallOrders from "../pages/install-orders/İnstallOrders";
import WarrantyTerms from "../pages/warrantyTerms/WarrantyTerms";
import ChatbotTemplates from "../pages/chatbot-templates/ChatbotTemplates";
import LiveSupport from "../pages/live-support/LiveSupport";
import Messaging from "../pages/messaging/Messaging";
import Banner from "../pages/banner/Banner";
import Subscribe from "../pages/subscribe/Subscribe";
import InstagramGallery from "../pages/instagram-gallery/InstagramGallery";

const token = getCookie("BscAdminToken");
const ROUTES: RouteObject[] = [
  {
    path: "/",
    element: <Navigate to={`${token ? "/admin" : "login"}`} replace />,
  },
  {
    path: "/admin",
    element: <AdminRoot />,
    children: [
      {
        path: "/admin/",
        element: <Dashboard />,
      },
      // {
      //   path: "admins",
      //   element: <Admins />,
      // },
      {
        path: "settings",
        element: <Settings />,
      },
      // {
      //   path: "languages",
      //   element: <Languages />,
      // },
      {
        path: "categories",
        element: <Categories />,
      },
      {
        path: "products",
        element: <Products />,
      },
      {
        path: "brands",
        element: <Brands />,
      },
      {
        path: "countries",
        element: <Countries />,
      },
      {
        path: "partners",
        element: <Partners />,
      },
      {
        path: "news",
        element: <News />,
      },
      {
        path: "colors",
        element: <Colors />,
      },
      {
        path: "pages",
        element: <Pages />,
      },
      // {
      //   path: "dictionary",
      //   element: <Dictionary />,
      // },
      {
        path: "category-specs",
        element: <CategorySpecs />,
      },
      {
        path: "permissions",
        element: <Permissions />,
      },
      {
        path: "slider",
        element: <Campaigns />,
      },
      {
        path: "services",
        element: <Services />,
      },
      {
        path: "category-specs-group-names",
        element: <GroupNames />,
      },
      {
        path: "vacancy",
        element: <Vacancy />,
      },
      {
        path: "blogs",
        element: <Blogs />,
      },
      {
        path: "videos",
        element: <Video />,
      },
      {
        path: "branchs",
        element: <Branchs />,
      },
      {
        path: "contact",
        element: <Contact />,
      },
      {
        path: "feedback",
        element: <RepairOrder />,
      },
      // {
      //   path: "warehouse",
      //   element: <Warehouse />,
      // },
      {
        path: "weekly_picks_products",
        element: <WeeklyPicks />,
      },
      {
        path: "services_groups",
        element: <ServicesGroup />,
      },
      {
        path: "order_status",
        element: <OrderStatus />,
      },
      {
        path: "about",
        element: <About />,
      },
      {
        path: "product_orders",
        element: <ProductOrders />,
      },
      {
        path: "service_orders",
        element: <ServiceOrders />,
      },
      // {
      //   path: "install_orders",
      //   element: <InstallOrders />,
      // },
      {
        path: "accessory_orders",
        element: <AccessoryOrders />,
      },
      {
        path: "official_service",
        element: <OfficialService />,
      },
      {
        path: "warranty-terms",
        element: <WarrantyTerms />,
      },
      {
        path: "chatbot-templates",
        element: <ChatbotTemplates />,
      },
      {
        path: "live-support",
        element: <LiveSupport />,
      },
      {
        path: "live-support/messaging/:id",
        element: <Messaging />,
      },
      {
        path: "banner",
        element: <Banner />,
      },
      {
        path: "subscribe",
        element: <Subscribe />,
      },
      {
        path: "furniture-gallery",
        element: <InstagramGallery />,
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default ROUTES;
